export type CorpUserData = {
	userId: string;
	userName: string;
	userType: string;
	departmentId: string;
	departmentName: string;
	departmentUiColor: string;
	accountName: string;
	accountNum: string;
	accountId: string;
	privateProfileMaster?: string;
};

const model: types.models.InputModel = {
	userId: 'response.getUserDepartmentForNumberResponse.result.userId',
	userName: 'response.getUserDepartmentForNumberResponse.result.userName',
	userType: 'response.getUserDepartmentForNumberResponse.result.userType',
	departmentId: 'response.getUserDepartmentForNumberResponse.result.departmentId',
	departmentName: 'response.getUserDepartmentForNumberResponse.result.departmentName',
	departmentUiColor: 'response.getUserDepartmentForNumberResponse.result.departmentUiColor',
	accountName: 'response.getUserDepartmentForNumberResponse.result.accountName',
	accountNum: 'response.getUserDepartmentForNumberResponse.result.accountNum',
	accountId: 'response.getUserDepartmentForNumberResponse.result.accountId',
	privateProfileMaster: 'response.getUserDepartmentForNumberResponse.result.privateProfileMaster',
};

export default model;
